import { shareLatest } from 'utils/rxUtil';
import { map, take } from 'rxjs/operators';

/**
 * Creates an authenticator for use by gRPC APIs.
 */
export function createGrpcAuthenticator(config) {
  var meta$ = config.token$.pipe(map(function (token) {
    return {
      Authorization: "Bearer ".concat(token)
    };
  }), shareLatest());
  return {
    meta$: meta$,
    getMeta: function getMeta() {
      return meta$.pipe(take(1)).toPromise();
    }
  };
}
//# sourceMappingURL=grpc-authenticator.js.map
